import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const LanguageContext = createContext({ lang: 'en', setLang: () => {} });

const STORAGE_KEY = 'sapot_lang';

const readInitialLang = () => {
  if (typeof window === 'undefined') return 'en';
  try {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');
    if (urlLang === 'cn' || urlLang === 'zh') return 'zh';
    if (urlLang === 'en') return 'en';
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'zh' || stored === 'en') return stored;
  } catch (e) {
    // ignore
  }
  return 'en';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(readInitialLang);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.setAttribute('lang', lang === 'zh' ? 'zh-CN' : 'en');
      const url = new URL(window.location.href);
      if (lang === 'zh') {
        url.searchParams.set('lang', 'cn');
      } else {
        url.searchParams.delete('lang');
      }
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next === 'zh' || next === 'cn' ? 'zh' : 'en');
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);

export const useT = (dict) => {
  const { lang } = useLang();
  return (dict && dict[lang]) || (dict && dict.en) || {};
};

export default LanguageContext;
